import { InvalidIdError } from 'activate-errors';
import { isUUID } from './isUUID';

/**
 * Validates that a 36-char string is a well-formed UUID.
 *
 * `convertToUUID` passes 36-char strings through without content validation,
 * which allows malformed values (e.g. address slugs) to reach Prisma and cause
 * a `PrismaClientKnownRequestError`. Call this before `convertToUUID` at any
 * trust boundary (e.g. GraphQL scalar input parsing) to reject bad input early.
 *
 * Non-36-char strings are ignored — `convertToUUID` already handles those
 * formats (base62, naked hex) or rejects them with its own `InvalidIdError`.
 *
 * Throws `InvalidIdError` for malformed 36-char strings.
 */
export function validateUUID(id: string): void {
  if (id.length === 36 && !isUUID(id)) {
    throw new InvalidIdError(`Invalid UUID format: "${id}"`);
  }
}
